import { Observable } from 'rxjs';

export interface HistoricalTokenBalanceFacade {
    cachedHistoricalTokenBalanceDates$: Observable<any>;

    getHistoricalTokenBalance(params: any): Observable<any>;

    getHistoricalTokenBalanceDatesSnapshot(): any;
}